import styled, { css } from 'styled-components';

import { ThemeOptionEnum } from '~/common/enum/theme-option-enum';
import { Z_INDEX } from '~/common/constants/z-index';
import { SPACING } from '~/common/constants/spacing';
import { Drawer } from '@mui/material';

export const SidebarContainer = styled.div<{
  themeOption: ThemeOptionEnum;
}>`
  background-color: ${({ theme }) => theme.neutral[950]};
  height: 100%;
  transition: 200ms;
  width: 220px;
  min-width: 220px;
  padding: ${SPACING._20};
  display: flex;
  flex-direction: column;
  gap: ${SPACING._20};
  z-index: ${Z_INDEX.SIDEBAR};
  ${({ themeOption }) =>
    themeOption === ThemeOptionEnum.light
      ? css`
          box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
        `
      : css`
          border-right: 1px solid ${({ theme }) => theme.neutral[800]};
        `}

  @media (max-width: 1279px) {
    width: 380px;
    max-width: 100vw;
  }
`;

export const SidebarFooter = styled.footer`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: auto;

  @media (max-width: 750px) {
    margin-top: 0;
  }

  li {
    width: 100%;
  }
`;

export const FavoritesWrapper = styled.div<{
  collapsed: boolean;
}>`
  > div {
    max-height: 350px;
    overflow-y: auto;
    scrollbar-width: thin;
    overflow-x: hidden;

    @media (max-width: 750px) {
      max-height: 200px;
    }

    ${({ collapsed }) =>
      collapsed &&
      css`
        /* Oculta scrollbar no Chrome, Safari e Edge */
        &::-webkit-scrollbar {
          display: none;
        }

        /* Oculta scrollbar no Firefox */
        scrollbar-width: none;

        /* Evita o espaço da scrollbar no Firefox */
        -ms-overflow-style: none; /* IE e Edge antigo */
      `}
  }

  ${({ collapsed }) =>
    collapsed &&
    css`
      /* Oculta o scrollbar no Chrome, Edge e Safari */
      &::-webkit-scrollbar {
        display: none;
      }

      /* Oculta o scrollbar no Firefox */
      scrollbar-width: none; /* Firefox */

      /* Evita quebra de layout */
      -ms-overflow-style: none; /* Internet Explorer e Edge Legacy */
    `}
`;

export const StyDrawerMUI = styled(Drawer)``;
